import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const Container = styled.div`
  border-top: 1px solid ${({ theme }) => theme.COLORS.BORDER};
  padding-top: 20px;
`;

export const Header = styled.div`
  ${FLEX.FlexBetweenCenter};
  padding-bottom: 8px;

  ${mediaQuery.isDefault} {
    justify-content: flex-start;
    gap: 50px;
  }

  ${mediaQuery.isMobile} {
    flex: 0 0 auto;
  }
`;

export const TableContainer = styled.div`
  display: flex;
  flex: 1;

  .table-container {
    min-height: calc(100% - 260px);
  }
`;

export const Status = styled.ul`
  ${FLEX.FlexEndCenter};
  gap: 20px;

  ${mediaQuery.isDefault} {
    justify-content: flex-start;
  }
`;

export const StatusItem = styled.li`
  font-weight: 500;
  font-size: ${calcRem(18)};
  color: ${COLORS.BUTTONS1};

  strong {
    color: #828b9b;
  }
`;

export const ButtonWrapper = styled.div`
  ${FLEX.FlexEndCenter};
  gap: 10px;

  button {
    padding: 10px;
    min-width: 100px;
  }
`;

export const InforamtionTitle = styled.div`
  width: 100%;
  .information-title {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;

    ${mediaQuery.isMobile} {
      font-size: ${calcRem(14)};
    }
  }
`;

export const ConfigureDownload = styled.button`
  padding: 4px;
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.BUTTONS1 : COLORS.BUTTONS2};
  color: ${COLORS.WHITE};
  border-radius: 2px;

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.COLORS.DISABLED_BORDER};
    opacity: 0.5;
  }
`;

export const ConfigureStyled = {
  Description: styled.div`
    font-size: ${calcRem(14)};
    ${FLEX.FlexStartStart};
    gap: 4px;
    color: ${({ theme }) => theme.COLORS.VALIDATERED};
    margin-top: -15px;
    margin-bottom: 20px;
  `,
  Inner: styled.div`
    width: 100%;
    color: ${({ theme }) => theme.COLORS.WHITE};
    background-color: ${({ theme }) => theme.COLORS.LIGHTGRAYBORDER};
    padding: 16px 20px;
    ${FLEX.FlexStartStart};
    flex-direction: column;

    h3 {
      padding-bottom: 20px;
      font-weight: 500;
      font-size: ${calcRem(18)};
    }

    .setting {
      font-weight: 500;
      ${FLEX.FlexStartStart};
      flex-direction: column;
      color: ${({ theme }) => theme.COLORS.WHITE};
      gap: 16px;
      counter-reset: list;

      > li {
        ${FLEX.FlexStartStart};
        gap: 4px;
        counter-increment: list;
        position: relative;
        padding-left: 24px;
        font-size: ${calcRem(14)};
        color: ${({ theme }) => theme.COLORS.WHITE}90;
        b {
          color: ${({ theme }) => theme.COLORS.WHITE};
        }

        .web-app-link {
          font-size: ${calcRem(14)};
        }

        .import-system {
          ${FLEX.FlexStartStart};
          flex-direction: column;
          gap: 10px;

          .config-bg {
            border-radius: 4px;
            overflow: hidden;
            width: 100%;
            background-color: ${COLORS.PRIMARY3};
            padding: 2px;

            img {
              width: 90%;
            }
          }
        }

        :before {
          content: counter(list) ". ";
          position: absolute;
          left: 0;
          color: ${({ theme }) => theme.COLORS.WHITE}90;
        }
      }
    }
  `,
};
